(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /*
   * Ouvre les menus déroulants Dawn au survol sur ordinateur.
   * Le fonctionnement par clic est conservé sur mobile et pour le clavier.
   */
  const desktopMenuHoverMedia = window.matchMedia('(min-width: 990px)');

  function setMenuDisclosureState(details, isOpen) {
    if (isOpen) {
      details.setAttribute('open', '');

      const submenu = details.querySelector(':scope > .header__submenu');
      const isNestedMenu = details.parentElement && details.parentElement.closest('.header__submenu');

      if (submenu && isNestedMenu) {
        details.classList.remove('menu-opens-left');

        window.requestAnimationFrame(() => {
          const submenuBounds = submenu.getBoundingClientRect();

          if (submenuBounds.right > window.innerWidth - 8) {
            details.classList.add('menu-opens-left');
          }
        });
      }
    } else {
      details.removeAttribute('open');
      details.classList.remove('menu-opens-left');

      details.querySelectorAll('details[open]').forEach((nestedDetails) => {
        nestedDetails.removeAttribute('open');
        nestedDetails.classList.remove('menu-opens-left');

        const nestedSummary = nestedDetails.querySelector(':scope > summary');
        if (nestedSummary) nestedSummary.setAttribute('aria-expanded', 'false');
      });
    }

    const summary = details.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  function initializeDesktopMenuHover(root = document) {
    root.querySelectorAll('.header__inline-menu details').forEach((details) => {
      if (details.dataset.hoverMenuInitialized === 'true') return;

      details.dataset.hoverMenuInitialized = 'true';
      let closeTimer;

      details.addEventListener('mouseenter', () => {
        if (!desktopMenuHoverMedia.matches) return;

        window.clearTimeout(closeTimer);
        setMenuDisclosureState(details, true);
      });

      details.addEventListener('mouseleave', () => {
        if (!desktopMenuHoverMedia.matches) return;

        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          setMenuDisclosureState(details, false);
        }, 180);
      });

      details.addEventListener('focusin', () => {
        if (!desktopMenuHoverMedia.matches) return;

        window.clearTimeout(closeTimer);
        setMenuDisclosureState(details, true);
      });

      details.addEventListener('focusout', (event) => {
        if (!desktopMenuHoverMedia.matches || details.contains(event.relatedTarget)) return;

        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          setMenuDisclosureState(details, false);
        }, 180);
      });
    });
  }

  initializeDesktopMenuHover();

  document.addEventListener('shopify:section:load', (event) => {
    initializeDesktopMenuHover(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
